import React from "react";
import { connect } from "react-redux";
import { replace } from "react-router-redux";

import { Logo } from "../../../core/atoms";
import * as WebRoutes from "@travellocal/utils/webRoutes";
import { ActionPromises } from "../../state/actionPromises";

interface DispatchProps {
  logoutAndGoHome: () => void;
}

class Logout extends React.PureComponent<DispatchProps, {}> {
  public componentWillMount() {
    this.props.logoutAndGoHome();
  }

  public render() {
    return (
      <div>
        <Logo type="accent" link="/" width={135} />
        <h1>Signing out of TravelLocal...</h1>
        <p>If you're not redirected after a few seconds, <a href={globalConfig.wwwBaseUrl}>click here</a>.</p>
      </div>
    );
  }
}

const dispatchToProps = (dispatch): DispatchProps => {
  return {
    logoutAndGoHome: async () => {
      await dispatch(ActionPromises.logout());
      await dispatch(replace(WebRoutes.index()));
    }
  };
};

export default connect(null, dispatchToProps)(Logout);
